import { useCallback } from 'react';

import {
  createSpec, specTypes,
  useFetch,
  useRefetch,
  useMutation,
  useDataRefId,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';

import {
  mutationRequestContract,
  mutationEntityResponseContract,
} from '../spec/mutation';
import { environmentLookupFn } from '../../../environment/index';

const fetchSpec =
  createSpec(
    fetchRequestContract, fetchResponseContract,
    specTypes.FETCH, null, environmentLookupFn
  );
const mutationSpec =
  createSpec(
    mutationRequestContract, mutationEntityResponseContract,
    specTypes.MUTATION, null, environmentLookupFn
  );
const refetchSpec =
  createSpec(
    fetchRequestContract, fetchResponseContract,
    specTypes.REFETCH, null, environmentLookupFn
  );

export function useCampaign(dataLocator, config = {}) {
  const dataRefId = useDataRefId(null, environmentLookupFn);
  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator);

  const { mutation = {}, refetch = {} } = config;
  const updateFn = useMutation(dataRefId, mutationSpec, mutation.update);

  const update = useCallback((item) => {
    if (Array.isArray(item)) {
      throw Error('useCampaign cannot update multiple object. Do not provide array as argument.');
    }
    updateFn({ ...dataLocator }, item);
  }, [dataLocator, updateFn]);

  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const read = useCallback((param) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    });
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { update, read }];
}
